import { useNavigate } from "react-router";
import CommonIcon, { IconList } from "./common/CommonIcon";
import Styled from 'styled-components';
import { useApp } from "../App";
import ConfigItem from "../interfaces/ConfigItem";

const Container = Styled.div<{ disabled?: boolean }>`
	margin: 10px;
	border-radius: 10px;
	overflow: hidden;

	backdrop-filter: blur(10px);
	box-shadow: 3px 3px 10px rgba(17, 17, 17, .5);
	
	transition: transform linear .05s, background-color ease-in-out .1s;
	
	border: 2px solid rgba(0, 137, 150, 0.3);

	display: flex;
	text-align: left;

	min-height: 72px;

	${p => !p.disabled && `
		background-color: rgba(0, 130, 149, .6);
		color:white;
		cursor: pointer;

		&:hover {
			transform: scale(1.025);
			background-color: rgba(0, 130, 149, .8);
		}
	`}
	${p => p.disabled && `
		color: grey;
		border: 2px solid rgba(49, 49, 49, 0.3);
		cursor: not-allowed;
	`}

	.icon {
		font-size: 30pt;
		padding-left: 15px;
		padding-right: 15px;
		border-radius: 10px;
		background-color:rgba(0, 0, 0, .25);
		padding-top: 5px;
		&.compact {
			//margin-top:-8px;
		}
	}
	.title {
		font-size: 17pt;
	}
	.detail {
		flex: 1;
		padding: 10px;
		padding-left: 20px;

		display: flex;
		flex-direction: column;
		justify-content: center;
		

		.title {
		}
		.description {

		}
	}
`;

interface TileProps {
	to: string,
	title: string,
	description?: string,
	icon: IconList
	disabled?: boolean,
	exact?: boolean,
	target?: "_blank" | "_self",
}

export default function WideTile(props: TileProps) {
	const navigate = useNavigate();
	const app = useApp();

	const onClick = () => {
		if (props.disabled) {
			return;
		}

		if (props.to.toLocaleLowerCase().startsWith("http")) {
			if (props.target && props.target === "_blank") {
				window.open(props.to, "_blank");
			} else {
				window.location.href = props.to;
			}
		} else if (props.to.toLocaleLowerCase().startsWith("modal://")) {
			const url = new URL(props.to);
			console.log(`Opening modal URL`, url, props.to);
			app.showModal(url.host);
		} else {
			if (props.exact) {
				if (props.target && props.target === "_blank") {
					window.open(props.to, "_blank");
				} else {
					window.location.href = props.to;
				}
				return;
			}
			navigate(props.to);
		}
	}

	return (
		<Container onClick={onClick} disabled={props.disabled}>
			<div className={(props.description ? "icon" : "icon compact")}>
				<CommonIcon icon={props.icon} style={{ color: (props.icon === "heart" && "#E74C3C" || "inherit") }} />
			</div>
			<div className="detail">
				<div className="title">{props.title}</div>
				{props.description && <div className="description">{props.description}</div>}
			</div>
		</Container>
	);
}